import { createTheme } from "@mui/material/styles";

const currentLang = localStorage.getItem("language") || "en";
const isArabic = currentLang === "ar";
const textAlignVariants = [
  "h1", "h2", "h3", "h4", "h5", "h6",
  "subtitle1", "subtitle2", "body1", "body2",
  "caption", "overline"
];

const baseTypography :any= {
  fontFamily: "Poppins",
  button: {
    textTransform: "none",
  },
};

textAlignVariants.forEach(variant => {
  baseTypography[variant] = {
    textAlign: isArabic ? "right" : "left",
  };
});
const theme = createTheme({
  palette: {
    primary: {
      main: "#0d47a1",
    },
    secondary: {
      main: "#f50057",
    },
  },
  
  typography: {
    fontFamily: "Poppins",
    ...baseTypography,

    h4: {
      fontWeight: 700,
      textAlign: isArabic ? "right" : "left",
    },
    button: {
      textTransform: "none",
    },
    body1: {
      textAlign: isArabic ? "right" : "left",
    },
    body2: {
      textAlign: isArabic ? "right" : "left",
    },
  },
});

export default theme;

export const getDesignTokens = (mode: any) => ({
  palette: {
    mode,
    ...(mode === "light"
      ? {
          background: {
            default: "#f5f5f5",
            paper: "#fff",
          },
          text: {
            primary: "#000",
            secondary: "#333",
          },
        }
      : {
          background: {
            default: "#0f0f0f",
            paper: "#1a1a1a",
          },
          text: {
            primary: "#fff",
            secondary: "#ccc",
          },
        }),
  },
  typography: {
    textAlign: isArabic ? "right" : "left",
    fontFamily: "Poppins",
  },
});
